// Generated by scripts/update-seeq-icons.js from src/svg/seeq/bell-regular.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcBellRegular = {
  prefix: 'fak',
  iconName: 'bell-regular' as IconName,
  icon: [
    896,
    1024,
    [],
    'e9a2',
    'M448 0c-35.4 0-64 28.6-64 64v35.8c-145 23-256 148.6-256 300.2v66.8c0 90.8-31 179-87.6 249.8l-29.8 37.4c-11.6 14.4-13.8 34.2-5.8 50.8s24.8 27.2 43.2 27.2h800c18.4 0 35.2-10.6 43.2-27.2s5.8-36.4-5.8-50.8l-29.8-37.2c-56.6-71-87.6-159.2-87.6-250v-66.8c0-151.6-111-277.2-256-300.2v-35.8c0-35.4-28.6-64-64-64zM448 192h16c114.8 0 208 93.2 208 208v66.8c0 95.8 27.8 189.2 79.4 269.2h-606.8c51.6-80 79.4-173.4 79.4-269.2v-66.8c0-114.8 93.2-208 208-208h16zM576 896h-256c0 34 13.4 66.6 37.4 90.6s56.6 37.4 90.6 37.4 66.6-13.4 90.6-37.4 37.4-56.6 37.4-90.6z',
  ],
} satisfies IconDefinition;
